<template>
    <span class="live-event-date" v-if="date">{{ date }}
        <span v-if="showTime">{{ $t("LiveEventDate.at") }} {{ time }}</span>
    </span>
</template>

<script>
    export default {
        name: 'totem-live-event-date',
        props: {
            date: [ String, Number ],
            time: [ String, Number ],
            isCourseItem: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            showTime () {
                return this.time && this.isCourseItem

            }
        }
    }
</script>

<style lang="scss" scoped>
    .live-event-date {
        position: relative;
        margin: 0 10px 0 20px;

        &:before {
            content: "\e958";
            font-family: 'icomoon';
            width: 10px;
            height: 12px;
            position: absolute;
            display: inline-block;
            left: -20px;
            top: 1px;
        }
    }
</style>
